export enum AppPaletteMode {
  Light = 'light',
  Dark = 'dark',
}
